import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NodeItem } from './models/node.model';
import { ConfirmComponent } from '../modal/confirm.component';

@Component({
    selector: 'file-manager',
    templateUrl: 'file-manager.component.html',
    standalone: false
})
export class FileManagerComponent implements OnInit {
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  @Input()
  set nodes(nodes: NodeItem[]) {
    this._nodes = nodes;
    this.node = null;
  }
  @Input() public query: string;
  @Input() public options: any;

  @Output() public toggleSelectNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleOpenNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleGotoNodeParent: EventEmitter<any> = new EventEmitter();
  @Output() public toggleOpenFileNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleExpandNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCloseNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCreateFolder: EventEmitter<any> = new EventEmitter();
  @Output() public toggleUploadFiles: EventEmitter<any> = new EventEmitter();
  @Output() public toggleDeleteNodes: EventEmitter<any> = new EventEmitter();
  private _nodes: NodeItem[];
  get nodes(): NodeItem[] {
    return this._nodes;
  }

  public node: NodeItem;
  constructor() {}

  ngOnInit() {}

  selectNode(node: NodeItem) {
    this.toggleSelectNode.emit(node);
    node.selected = !node.selected;
  }

  openNode(node: NodeItem) {
    if (node.fileNode) {
      this.toggleOpenFileNode.emit(node);
      return;
    }
    this.closeNodes(this.nodes);
    if (this.node) {
      this.deselectChildren(this.node);
    }
    node.opened = true;
    this.node = node;
    this.toggleOpenNode.emit(node);
  }

  gotoNodeParent(node: NodeItem) {
    this.toggleGotoNodeParent.emit(node);
    this.openNode(node.parent);
  }

  expandNode(node: NodeItem) {
    this.toggleExpandNode.emit(node);
  }

  closeNode(node: NodeItem) {
    this.toggleCloseNode.emit(node);
  }

  createFolder() {
    if (this.node) {
      this.toggleCreateFolder.emit();
    }
  }

  uploadFile() {
    if (this.node) {
      this.toggleUploadFiles.emit();
    }
  }

  handleInputChange(e: any) {
    if (this.node) {
      const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
      if (files && files.length) {
        this.toggleUploadFiles.emit(files);
      }
    }
  }

  clearInput(e: any) {
    e.target.value = null;
  }

  anySelected() {
    if (this.node) {
      return this.node.children.some((n) => n.selected);
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deleteNodes() {
    const selectedNodes = this.node.children.filter((n) => n.selected);
    this.toggleDeleteNodes.emit(selectedNodes);
  }

  private closeNodes(nodes: NodeItem[]) {
    nodes.forEach((n) => {
      n.opened = false;
      if (n.children && n.children.length) {
        this.closeNodes(n.children);
      }
    });
  }

  private deselectChildren(node: NodeItem) {
    if (node.children) {
      node.children.forEach((n) => (n.selected = false));
    }
  }
}
